/****
 Name: DataTable.vue
 Author: Kao Saetern
 Purpose: Reusable datatable component
 Parameters:
 	id: {
 		required - component use this to identify the table.
 	},
 	api: {
 		required - component use this to request data from the api
 	},
 	headers: {
		required - component use this to identify the headers.
		The following fields are required:
			{ 
				title: 'Title' - Title to Display in header, 
				data: 'client.location.location_name' - Reference the data object to display,
				name: 'location_name' - Actual table column name - use for sorting
			}
		Other fields can be added, most common:
			{
				width: '100px' - For fixed column - add width so column width do not shift,
				defaultContent: '' - Need this when foreign key is undefined otherwise datatable will throw an error like this: "DataTables warning: table id={id} - Requested unknown parameter '{parameter}' for row {row-index}, column{column-index}`"
			}
 	},
 	store: {
		required - component use this to identify vuex store for pushing data to the form.
 	},
 	faction: {
		required - component use this to idenfity vuex action for pushing data to the form.
 	},
 	taction: {
		required - component use this to idenfity vuex action for pushing data to the table.
 	},
 	xaction: {
		optional - An extra action that is called on successful table load.
 	},
 	include: {
		optional - for api model with availableInclude e.g include=client
 	},
 	fixed: {
		optional - identify the column to be fixed 
		default - 1 //first column
 	},
 	corder:{
 		optional - sets the default column to be ordered
 		default - [0, "desc"]
 	},
 	height:{
		optional - define height of table 
		default - 70vh
 	}
***/
<template>
  <div>
    <table
      class="hover cell-border"
      :id="id"
    ></table>
  </div>
</template>

<script>
import DataTable from "datatables.net";
//import DataTableButtons from 'datatables.net-buttons'

export default {
  name: "datatable",
  props: {
    id: {
      type: String,
      default: "table",
    },
    headers: {
      default: "",
    },
    api: {
      default: "",
    },
    include: {
      default: "",
    },
    store: {
      default: "",
    },
    faction: {
      default: "",
    },
    taction: {
      default: "",
    },
    xaction: {
      default: "",
    },
    fixed: {
      default: 1,
    },
    corder: {
      default: function () {
        var arr = [0, "desc"];
        return arr;
      },
    },
    height: {
      default: "calc(100vh - 292px)",
    },
  },
  data() {
    return {
      dtHandle: null,
      isExportDataLoaded: false,
      exportData: false,
      exportPDF: false,
      exportCSV: false,
      exportPrint: false,
      trid: "",
    };
  },
  watch: {
    isExportDataLoaded: function (val) {
      if (val === true) {
        //console.log("Watching isExportDataLoaded");
        this.isExportDataLoaded = false;

        //console.log("PDF: "+this.exportPDF);
        //console.log("CSV: "+this.exportCSV);
        if (this.exportPDF == true) {
          this.generatePDF();
        }

        if (this.exportCSV == true) {
          this.generateCSV();
        }

        if (this.exportPrint == true) {
          this.generatePrint();
        }
      }
    },

    exportData: function (val) {
      //this.export();
    },
  },

  mounted() {
    this.getTrId();

    let vm = this;

    // datatable id
    var table_id = `#${this.id}`;

    //var header = 'Bearer '.concat(JSON.parse(sessionStorage.getItem("ACCESS_TOKEN")));
    var navPage;
    var sortName;

    // column to sort
    var sorder = vm.corder;

    // column(s) to make it fixed
    var fixedColumn = vm.fixed;

    // height of table body
    var height = vm.height;

    /**
     * Reports Tab has the following routes
     * /reports/dmv
     * /reports/excel
     * /reports/payroll
     */
    var module = vm.api;

    var url = VueStore.state.auth.l + "v1/" + module;

    var activeHeaderDisplayName = VueStore.state.nav.activeHeaderDisplayName;

    var pathToFormAction = this.store + "/" + this.faction;
    var pathToTableAction = this.store + "/" + this.taction;

    var pathToExtraAction = "";
    if (this.xaction != "") {
      pathToExtraAction = this.store + "/" + this.xaction;
    }
    // usage for refreshing table.
    var refreshTableURL = vm.store + "/setTableRefresh";
    // usage for displaying butttons
    var displayingButtonURL = vm.store + "/setShowButton";
    // for table loading
    var tableLoadingURL = vm.store + "/setTableLoading";

    // dispatch store to keep track of which table to refresh after update or create
    VueStore.dispatch(refreshTableURL, this.id);

    var buttonCommon = {
      exportOptions: {
        orthogonal: {
          display: ":null",
        },
      },
    };

    // Initialize datatable
    vm.dtHandle = $(table_id).DataTable({
      dom: "Bfrtip",
      //dom: "Rlfrtip",
      colReorder: {
        fixedColumnsLeft: fixedColumn,
      },
      rowId: vm.trid,
      //select: true,
      select: {
        info: false,
      },
      buttons: [
        $.extend(true, {}, buttonCommon, {
          extend: "pdfHtml5",
          download: "open",
          stripHtml: true,
          title: "Report",
          customize: function (doc) {
            doc.defaultStyle.fontSize = 10;
            doc.styles.tableHeader.fontSize = 10;
          },
        }),
        $.extend(true, {}, buttonCommon, {
          extend: "csv",
          download: "open",
          stripHtml: true,
          filename: "report",
        }),
        $.extend(true, {}, buttonCommon, {
          extend: "print",
          title: "Report",
          stripHtml: true,
          orientation: "landscape",
          customize: function (doc) {
            $(doc.document.body).find("h1").css({
              "font-size": "20px",
              "text-align": "center",
              "margin-bottom": "15px",
            });
          },
        }),
      ],
      ordering: true,
      order: [sorder],
      orderClasses: false,
      scrollY: height,
      scrollX: true,
      stateSave: true,
      searching: false,
      autoWidth: true,
      bLengthChange: false,
      paging: true,
      bInfo: true,
      pageLength: 30,
      columns: vm.headers,
      pagingType: "input",
      language: {
        info: "Records _START_ - _END_ from _TOTAL_",
        paginate: {
          first: "< First",
          previous: "Previous",
          next: "Next",
          last: "Last >",
        },
        processing: "Loading",
      },
      serverSide: true,
      prcessing: true,
      ajax: function (data, callback, settings) {
        // get sort order information
        var index = data.order[0].column;
        var sortDirection = data.order[0].dir;
        var colName = data.columns[index].name;

        var dbName;
        //'name' variable has to exist otherwise we won't know which column to sort therefore we'll default to sorting by id
        if (typeof data.columns[index].name !== "undefined") {
          dbName = data.columns[index].name;
        } else {
          dbName = "id";
        }
        //console.log(data);

        var sortBy = VueStore.state.datatable.resetTable;

        // set sort order
        if (sortBy) {
          sortName = "request_id:desc";
        } else {
          sortName = dbName + ":" + sortDirection;
        }

        //console.log("sort order: "+sortName);

        // get page number from datatable api
        var api = this.api();

        navPage = api.page() + 1;
        //console.log("navPage: "+navPage);

        var params;

        // paginate is set to false when generating exports
        var isExport = vm.exportData;

        if (isExport === true) {
          params = {
            paginate: false,
            sort: sortName,
          };
        } else {
          params = {
            page: navPage,
            sort: sortName,
          };
        }

        //Check for Find Requests filter values, only applicable when the tab is active\
        var activeRequestsTab = VueStore.state.nav.activeRequestsTab;

        var result;
        switch (activeRequestsTab) {
          case "info": // this allows filtered to be sorted while in info tab
          case "view-requests":
            result = VueStore.state.filter.filterData;
            _.merge(params, result);
            break;
        }

        //console.log(params);

        // ajax call to retrieve table data
        $.ajax({
          url: url,
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              "Authorization",
              "Bearer " + VueStore.state.auth.a
            );
          },
          type: "GET",
          dataSrc: "data",
          contentType: "application/x-www-form-urlencoded",
          data: params,
          success: function (data, textStatus, jQxhr) {
            // set current table data in vuex store
            VueStore.dispatch(pathToTableAction, data.data);

            if (pathToExtraAction != "") {
              VueStore.dispatch(pathToExtraAction, navPage + " " + sortName);
            }

            // if export is activated
            // set isExportDataLoaded to true
            if (isExport === true) {
              // Set isExportDataLoaded
              vm.isExportDataLoaded = true;
            }
            // set loading to false
            VueStore.dispatch(tableLoadingURL, false);

            callback({
              data: data.data,
              recordsTotal: data.meta.pagination.total,
              recordsFiltered: data.meta.pagination.total,
              page: data.meta.pagination.current_page,
            });

            // auto select first row
            //var row = vm.dtHandle.rows(0).data();
            var resetTable = VueStore.state.datatable.resetTable;

            if (resetTable) {
              // reset to page 1 and select first row
              //console.log("ajax reload - reset table");
              VueStore.dispatch(vm.store + "/selectFirstRow");
              VueStore.dispatch("datatable/setBoolean", {
                key: "resetTable",
                bool: false,
              });
            } else if (sessionStorage.getItem("USER-CLICKED-ROW") === "true") {
              //console.log("table refresh user-clicked-true");
              // we need to highlight previously selected row
              VueStore.dispatch(vm.store + "/userSelectRow");
            } //else {
            // only highlight first row on first log in.
            //var row = vm.dtHandle.rows(0).data();
            //console.log(row[0]);
            //VueStore.dispatch(vm.store + '/autoSelectRow', row[0]);
            //}
          },
          error: function (jqXhr, textStatus, errorThrown) {
            //console.log(jqXhr);
          },
        });
      },
      drawCallback: function () {
        // This will export datatable to pdf
        $("#export-pdf").on("click", function () {
          //console.log("export to pdf");
          // set sessionstorage PAINATE to false so we know to disable pagination.
          vm.exportData = true;
          vm.exportPDF = true;
          // Export loading
          VueStore.dispatch(vm.store + "/setExportLoader", true);
          // reload the table.
          vm.dtHandle.ajax.reload();
        });

        // This will export datatable to pdf
        $("#export-csv").on("click", function () {
          //console.log("export to excel");
          // set sessionstorage PAINATE to false so we know to disable pagination.
          vm.exportData = true;
          vm.exportCSV = true;
          // Export loading
          VueStore.dispatch(vm.store + "/setExportLoader", true);

          // reload the table.
          vm.dtHandle.ajax.reload();
        });

        // This will export datatable to pdf
        $("#export-print").on("click", function () {
          //console.log("print");
          // set sessionstorage PAINATE to false so we know to disable pagination.
          vm.exportData = true;
          vm.exportPrint = true;
          // Export loading
          VueStore.dispatch(vm.store + "/setExportLoader", true);

          // reload the table.
          vm.dtHandle.ajax.reload();
        });
      },
      preDrawCallback: function () {},
      initComplete: function () {
        $(table_id + " tr").disableSelection(); // disable row highlight on double click

        // on browser refresh.
        //console.log(typeof sessionStorage.getItem('USER-CLICKED-ROW'));
        if (sessionStorage.getItem("USER-CLICKED-ROW") === null) {
          //console.log('FALSE')
          // only highlight first row on first log in.
          var row = vm.dtHandle.rows(0).data();
          //console.log(row[0]);
          VueStore.dispatch(vm.store + "/autoSelectRow", row[0]);
        } else {
          //console.log('TRUE')
          // highlight user's previously selected row.
          var savedTRID = sessionStorage.getItem("TRID");
          var rowSelector = "#" + savedTRID;
          var row = vm.dtHandle.row(rowSelector).data();
          //console.log(row);
          VueStore.dispatch(vm.store + "/autoSelectRow", row);
        }

        //Detect DataTable row click
        $(table_id).on("click", "tr", function (e) {
          //console.log("row clicked");
          var $cell = $(e.target).closest("td");
          var $row = $(e.target).closest("tr");

          var row = vm.dtHandle.row(this).data();

          //console.log(row);
          $(table_id + " tbody tr").removeClass("selected");
          $(this).addClass("selected");

          //Save request id to sessionStorage for reselecting row when table gets refreshed by browser.

          sessionStorage.setItem("TRID", row.request_id);

          // use this to keep track when a user clicked on a row.
          VueStore.dispatch("nav/setVariables", {
            key: "userSelectTableRow",
            value: true,
          });
          sessionStorage.setItem("USER-CLICKED-ROW", true);

          // pass row data to vuex
          //console.log(row);
          VueStore.dispatch(pathToFormAction, row);

          //$(table_id+' tr').enableSelection(); //
        });

        //$(table_id+' tr').prop('title', 'Double click to select');

        // This will export datatable to pdf
        // $('#export-pdf').on('click', function() {
        // 	console.log("export to pdf");
        // 	// set sessionstorage PAINATE to false so we know to disable pagination.
        //     vm.exportData = true;
        //     vm.exportPDF = true;
        //     // Export loading
        //     VueStore.dispatch(vm.store+'/setExportLoader', true);
        //     // reload the table.
        //     vm.dtHandle.ajax.reload();
        // });

        //       // This will export datatable to pdf
        // $('#export-csv').on('click', function() {
        // 	console.log("export to excel");
        // 	// set sessionstorage PAINATE to false so we know to disable pagination.
        //     vm.exportData = true;
        //     vm.exportCSV = true;
        //     // Export loading
        //     VueStore.dispatch(vm.store+'/setExportLoader', true);

        //     // reload the table.
        //     vm.dtHandle.ajax.reload();
        // });

        //       // This will export datatable to pdf
        // $('#export-print').on('click', function() {
        // 	console.log("print");
        // 	// set sessionstorage PAINATE to false so we know to disable pagination.
        //     vm.exportData = true;
        //     vm.exportPrint = true;
        //     // Export loading
        //     VueStore.dispatch(vm.store+'/setExportLoader', true);

        //     // reload the table.
        //     vm.dtHandle.ajax.reload();
        // });

        //Auto-select first item
      },
    });
  },

  methods: {
    //Get <tr> id
    getTrId() {
      // var activeHeaderTab = VueStore.state.nav.activeHeaderTab;
      // var id = '';
      // switch(activeHeaderTab){
      // 	case 'vendors': id = 'vendor_id'; break;
      // 	default: id = 'request_id'; break;
      // }

      this.trid = "request_id";
    },

    // Generate pdf
    generatePDF() {
      this.dtHandle.button(".buttons-pdf").trigger();
      // set exportData false so when we reload the table
      // it will go back to pagination
      this.exportData = false;
      this.exportPDF = false;
      // disable loading
      VueStore.dispatch(this.store + "/setExportLoader", false);
      // reload the table
      this.refresh();
    },
    // Generate csv
    generateCSV() {
      this.dtHandle.button(".buttons-csv").trigger();
      // set exportData false so when we reload the table
      // it will go back to pagination
      this.exportData = false;
      this.exportCSV = false;
      // disable loading
      VueStore.dispatch(this.store + "/setExportLoader", false);
      // reload the table
      this.refresh();
    },
    // Generate csv
    generatePrint() {
      this.dtHandle.button(".buttons-print").trigger();
      // set exportData false so when we reload the table
      // it will go back to pagination
      this.exportData = false;
      this.exportPrint = false;
      // disable loading
      VueStore.dispatch(this.store + "/setExportLoader", false);
      // reload the table
      this.refresh();
    },

    // Reload the current table
    refresh() {
      this.dtHandle.ajax.reload();
    },
  },
};
</script>